import React from "react"

import { graphql } from "gatsby"

import Page from "../components/page"
import Lede from "../components/lede"
import GroupLogos from "../components/groupCompaniesLogoTree"
import GroupCompanyListing from "../components/groupCompanyListing"

export default ({ data }) => {
  return (
    <>
      <Page
        title="グループ会社一覧"
        description="TryHard Japan Groupは、音楽・文化・テクノロジーを通じて世界中の人々に感動と笑顔を与えるリーディングカンパニーを目指し、エンターテイメント事業による地方創生と日本の健全なナイトタイムエコノミーに貢献していきます。"
        fluid={data.pageHeader.childImageSharp.fluid}
      >
        <Lede>
          TryHard Japan
          Groupは、音楽・文化・テクノロジーを通じて世界中の人々に感動と笑顔を与えるリーディングカンパニーを目指し、エンターテイメント事業による地方創生と日本の健全なナイトタイムエコノミーに貢献していきます。
        </Lede>
        <GroupLogos />
        <GroupCompanyListing />
      </Page>
    </>
  )
}

export const pageQuery = graphql`
  query {
    pageHeader: file(relativePath: { eq: "palm-trees-sunset.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
